import React from "react";
import Header from "../../../components/ui/Header";
import Footer from "../../../components/ui/Footer";
import WhatsAppButton from "../../../components/ui/WhatsAppButton";

const CompaniesCoaches = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 w-full pt-20 pb-16 px-5 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">

                {/* IMAGEN (arriba en móvil) */}
                <div className="md:w-1/2 flex justify-center order-1 md:order-2">
                    <img
                        src="/assets/images/companies-coaches.jpg"
                        alt="Companies Coaches"
                        className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-full"
                    />
                </div>

                {/* TEXTO */}
                <div className="md:w-1/2 space-y-5 order-2 md:order-1">
                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-headline font-bold text-indigo-900 leading-tight">
                        CAPACITACIONES PARA EMPRESAS
                        <span className="block w-20 h-1 bg-purple-400 rounded-full mt-3"></span>
                    </h1>

                    <p className="text-base md:text-lg leading-relaxed text-justify">
                        Nos enfocamos en maximizar el potencial del capital humano de las organizaciones mediante un
                        enfoque innovador que integra técnicas modernas y herramientas avanzadas.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify">
                        Asesoramiento de Recursos Humanos y selección de personal aplicando comunicación no verbal y oratoria.
                        Capacitación en técnicas modernas, asesoramiento de imagen, inteligencia y comunicación persuasiva
                        para jefes y directores.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify">
                        Coaching ontológico para el manejo de conflictos, redacción eficaz y capacitación gerencial.
                    </p>

                    <p className="text-base md:text-lg font-bold text-justify text-indigo-900">
                        ¡Contáctanos hoy mismo y transforma tu organización!
                    </p>
                </div>

                <WhatsAppButton />
            </main>

            <Footer />
        </div>
    );
};

export default CompaniesCoaches;